import { Link } from "react-router-dom";
import CatalogTableC from "../../../components/Catalogs/CatalogTableC";
import Eye from "../../../components/Atomos/Icons/ViewMode/Eye";
import React, { useEffect, useMemo, useState, useCallback } from "react";
import BackgroundComponent from "../../../components/Layout/BackgroundProfile/BackgroundProfile";
import ProfileViewModeBg from '../../../assets/images&icons/profileViewMode.jpeg';
import { Option } from "../../../components/Atomos/DropDown/DDMultiple";
import { UsePracticeIndustryList } from "../../../hooks/Catalogs/usePracticeIndustry";
import { IOfficeNew } from "../../../interfaces/models/IOffice";
import { getOfficesByFirmId } from "../../../Services/Firm";
import { useSelector } from 'react-redux';
import { Appstore } from "../../../redux";
import { defaultPageSize } from "../../../utils/const";
import useDataLoader2 from "../../../hooks/useDataLoader2";
import PaginatedTable from '../../../components/Organismos/Table/PaginatedTable';
import { fetchPersonByFirm } from "../../../Services/Person";
import TabManager, { Tab } from "../../../components/Layout/TabManager/TabManager";
import Filters, { IFilterData } from "../../../components/Catalogs/Filters/Filters";
import { exportAllDataLoader2 } from "../../../utils/exportAllDataLoader2";
const WSGDots = require("../../../assets/images&icons/WSGDots.svg");

const AopManagement: React.FC = ({}) => {
  const manageFirm = useSelector((state: Appstore) => state.manageFirm);
  const [AOPFilters, setAOPFilters] = useState<any>([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const { practiceIndustryData: practiceIndustries } = UsePracticeIndustryList();
  const [firmOffices, setFirmOffices] = useState<(IOfficeNew)[]>([]);
  const [allPersons, setAllPersons] = useState<any[]>([]);

  const fields = [
    'id', 
    'legacyId',
    'name', 
    'professionals',
    'firms',
    'offices',
  ]
  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    filter,
    sort, 
    setSort, 
    pagination, 
    setPagination,
  } = useDataLoader2<any>({
    endpoint: '/areaOfPractice',
    defaultPageSize,
    fields,
    persistentFilter: {firms: {value: [manageFirm.selectedFirm?.id || ''], comparisonType: "EQUAL"}}
  });

  useEffect(() => {
    getAllPersons();
  }, []);

  const getAllPersons = async () => {
    const persons = await fetchPersonByFirm(manageFirm.selectedFirm?.id);
      setAllPersons(persons);
  };

  const filterProfessionalsByAopAndOffice = (aopName: string) => {
    if (allPersons && allPersons.length > 0) {
      if (selectedTab !== 0) {
        return allPersons.filter(person =>
          person.areasOfPractice?.some((aop: any) => aop.name === aopName) &&
          person.mainOffice === firmOffices[selectedTab - 1].id
        );
      } else {
        return allPersons.filter(person =>
          person.areasOfPractice?.some(
            (aop: any) => aop.name === aopName) &&
            firmOffices.some(office => office.id === person.mainOffice
          )
        );
      }
    }
    return [];
  };

  const getProfessionalCountForAopAndOffice = (aopName: string) => {
    const filteredProfessionals = filterProfessionalsByAopAndOffice(aopName);
    return filteredProfessionals.length;
  };

  const columnsDef = React.useMemo(() => [
    { 
      id: 'count', 
      header: '#', 
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p>{rowIndex + 1 + pagination.pageIndex * pagination.pageSize}</p>
      )
    },
    { id: 'name', header: 'Area Of Practice'},
    { 
      id: 'professionals', 
      header: '# Of Professionals',
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => {
        const aopName = row.name;
        const professionalCount = getProfessionalCountForAopAndOffice(aopName);
        return <p>{professionalCount}</p>;
      }
    },
    {
      id: 'edit',
      header: 'Actions',
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <Link
          className="edit"
          to={`/ManageFirm/aopManagement/professionals/${row.id}`}
          state={{
            name: row.name,
            firm: manageFirm.selectedFirm,
            filteredPersons: filterProfessionalsByAopAndOffice(row.name),
            selectedTab: selectedTab == 0 ? selectedTab : selectedTab.toString(),
          }}
        >
          View Professionals
          <div className="editsvg"><Eye /></div>
        </Link>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, selectedTab, allPersons, firmOffices, manageFirm.selectedFirm, filterProfessionalsByAopAndOffice, getProfessionalCountForAopAndOffice]);

  const practiceIndustriesAsFilterProps: Option[] = useMemo(() => {
    return practiceIndustries
      .filter(pi => pi != null && typeof pi.name === 'string')
      .map(pi => ({ id: pi.id, name: pi.name } as Option));
  }, [practiceIndustries]);

  const getFirmOffices = async (id: string) => {
    const data: any = await getOfficesByFirmId(id);
    if (data) {
      const updatedData = data.map((office: any) => ({
        ...office,
        action: () => {
          setSelectedTab(office.id);
        }
      }));
      setFirmOffices(updatedData);
    }
  };

  useEffect(() => {
    if (!manageFirm.selectedFirm?.id) {
      return
    }
    getFirmOffices(manageFirm.selectedFirm.id);
  }, [manageFirm.selectedFirm]);

  const filtersData: IFilterData[] = React.useMemo(() => [
    {
      name: "Name",
      type: "text",
      comparison: 'CONTAINS',
    },
    {
      name: "Practice Industry",
      fieldName: "practiceIndustries",
      objectData: practiceIndustriesAsFilterProps || [],
      comparison: 'BY_ID'
    },
  ], [practiceIndustriesAsFilterProps]);


  const tabs: Tab[] = [
    {
      title: 'Firm Wide',
      action: () => {
        setSelectedTab(0);
      },
    },
      ...firmOffices.map((office, index) => ({
        title: office.firmName ?? "",
        action: () => setSelectedTab(index + 1),
      }))
    ];
    return (
      <>
        <BackgroundComponent image={ProfileViewModeBg} />
        <div className="bg-gray-100 min-h-screen text-left px-4 py-7 items-start flex flex-col gap-[1.5rem] md:py-8 md:px-6 lg:py-10 lg:px-10 lg:gap-[2.5rem]">
          <div className="flex flex-col items-start gap-5 self-stretch">
            <div className="w-full relative z-10 flex gap-5 md:gap-6 lg:gap-7 self-stretch !p-0 flex-col ">
              <div className="flex p-0 flex-col justify-center gap-5 self-stretch md:flex-row lg:justify-between lg:gap-6">
                <h2 className="text-left w-full lg:w-max text-white font-decimal text-[2.25rem] font-medium leading-[2.75rem] md:text-[2.75rem] md:leading-[3.25rem] lg:text-[3.25rem] lg:leading-[4.5rem]">
                  Login History
                </h2>
                <div
                  className="self-stretch flex-1 hidden lg:flex"
                  style={{
                    backgroundImage: `url(${WSGDots.default})`,
                  }}
                ></div>
              </div>
              <hr className="flex h-0 justify-center items-center self-stretch relative z-10" />
              <div className="flex w-full">
              </div>
  
              <div className="">
                <TabManager tabs={tabs} selectedTabIndex={selectedTab} />
                <CatalogTableC
                  catalogName="AREAS OF PRACTICE"
                  catalogShortName="Area Of Practice"
                  route="AreaOfPractice"
                  totalCount={totalCount ?? 0}
                  linkToAdd="/manageFirm/aopManagement/update"
                >
                  <Filters
                    filtersData={filtersData} 
                    filterValues={AOPFilters}
                    setFilterValues={setAOPFilters} 
                    Search={() => fetchData()}
                    clearSelections={() => fetchData(true)}
                    setValueForQuery={setFilter}
                  />
                  <PaginatedTable
                    data={data || []}
                    columnsDef={columnsDef}
                    sorting={sort}
                    onSortingChange={setSort}
                    totalCount={totalCount || 0}
                    pagination={pagination}
                    onPaginationChange={setPagination}
                    endpoint="/areaOfPractice"
                    onExportAll={() =>
                      exportAllDataLoader2<any>({
                        endpoint: "/areaOfPractice",
                        filter,
                        sort,
                        pageSize: 1000,
                        fields,
                      })
                    }
                  />
                </CatalogTableC>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

export default AopManagement;
